import firebase from 'firebase';

const config = {
  apiKey: 'AIzaSyDKRFUsaOoBubosajIcKFsAnRWGbwyt9Qo',
  authDomain: 'cabanyes-entre-valls.firebaseapp.com',
  databaseURL: 'https://cabanyes-entre-valls.firebaseio.com',
  projectId: 'cabanyes-entre-valls',
  storageBucket: 'cabanyes-entre-valls.appspot.com',
  messagingSenderId: '140780001757'
};
firebase.initializeApp(config);



// WEBPACK FOOTER //
// ./src/firebase.js